import { PieChart } from '@opd/g2plot-react';
import { PackageCountWidgetProps } from './PackageCount';
import { useMemo } from 'react';
import useMediaQuery from 'hooks/useMediaQuery';
import { Flex, Skeleton } from 'antd';
import { useTranslation } from 'react-i18next';

const PackageCountChart = ({
  notShipped,
  shipped,
  delivered,
  invoiceUploaded: fulfilled,
  isLoading,
}: PackageCountWidgetProps) => {
  const isSmallScreen = useMediaQuery('(max-width: 766px)');
  const { t } = useTranslation();

  const data = useMemo(
    () => [
      // { type: 'Pending', value: notShipped },
      {
        type: t('packageTrackerDashboard.packageStatus.shipping'),
        value: shipped,
      },
      {
        type: t('packageTrackerDashboard.packageStatus.delivered'),
        value: delivered,
      },
      {
        type: t('packageTrackerDashboard.packageStatus.invoiceUploaded'),
        value: fulfilled,
      },
    ],
    [notShipped, shipped, delivered, fulfilled, t],
  );

  const config = useMemo(
    () => ({
      appendPadding: 10,
      data,
      angleField: 'value',
      colorField: 'type',
      radius: 1,
      innerRadius: 0.75,
      color: ['#FAAD14', '#4096FF', '#73D13D'], // not shipped, shipped, delivered, fulfilled, 'rgba(0, 0, 0, 0.15)',
      meta: {
        value: {
          formatter: () => ``, // Empty formatter required for hiding percentages in archs
        },
      },
      label: {
        type: 'inner',
        offset: '-60%',
        autoRotate: false,
        style: { textAlign: 'center' },
      },

      statistic: {
        title: {
          content: 'Total Packages',
          style: {
            fontSize: '14px',
            color: 'rgba(0, 0, 0, 0.45)',
            lineHeight: '30px',
            fontWeight: 400,
            fontFamily: 'Poppins',
          },
        },
        content: {
          content: `${(notShipped || 0) + (shipped || 0) + (delivered || 0)}`,
          style: {
            fontSize: isSmallScreen ? '18px' : '30px',
            color: 'rgba(0, 0, 0, 0.85)',
            fontFamily: 'Poppins',
          },
        },
      },
    }),
    [data, isSmallScreen, notShipped, shipped, delivered, fulfilled],
  );

  if (isLoading) return <PackageCountChartSkeleton />;

  return (
    <PieChart
      style={{
        height: '100%',
        minHeight: isSmallScreen ? 300 : 'auto',
      }}
      {...config}
    />
  );
};

function PackageCountChartSkeleton() {
  return (
    <Flex justify="center" align="center">
      <Skeleton.Avatar style={{ height: '200px', width: '200px' }} active />
    </Flex>
  );
}
export default PackageCountChart;
